/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.5821 11.6c-1.7412 0-3.1527 1.4115-3.1527 3.1527 0 1.7411 1.4115 3.1526 3.1527 3.1526 1.7411 0 3.1526-1.4115 3.1526-3.1526 0-1.7412-1.4115-3.1527-3.1526-3.1527Zm-1.7979 3.1527c0-.9929.805-1.7978 1.7979-1.7978.9928 0 1.7978.8049 1.7978 1.7978 0 .9929-.805 1.7978-1.7978 1.7978-.993 0-1.7979-.8049-1.7979-1.7978Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M4.3549 12.538a.6774.6774 0 0 0-.6774-.6774A.6774.6774 0 0 0 3 12.538v4.6378c0 .4029.3266.7295.7296.7295H6.283a.6774.6774 0 1 0 0-1.3548H4.3549V12.538ZM17.8775 12.9549c-.9929 0-1.7978.8049-1.7978 1.7978 0 .9929.8049 1.7978 1.7978 1.7978.6038 0 1.139-.298 1.4652-.7556l-.7919.0257a.6775.6775 0 0 1-.0439-1.3542l1.7402-.0563c.4457-.0145.8176.3789.7435.8428a3.1448 3.1448 0 0 1-.089.3932c-.3853 1.3054-1.5924 2.2592-3.0241 2.2592-1.7412 0-3.1527-1.4115-3.1527-3.1526 0-1.7412 1.4115-3.1527 3.1527-3.1527.7201 0 1.3855.2422 1.9165.6493a.6774.6774 0 1 1-.8242 1.0753 1.7869 1.7869 0 0 0-1.0923-.3697Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 0c-.9665 0-1.75.7835-1.75 1.75v7.0945C.956 9.1775 0 10.3521 0 11.75V18c0 1.3979.956 2.5725 2.25 2.9055V22.25c0 .9665.7835 1.75 1.75 1.75h16c.9665 0 1.75-.7835 1.75-1.75v-1.3445C23.0439 20.5725 24 19.3979 24 18v-6.25c0-1.3979-.9561-2.5725-2.25-2.9055V1.75C21.75.7835 20.9665 0 20 0H4Zm-.25 22.25V21h16.5v1.25a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25Zm16.5-13.5v-7A.25.25 0 0 0 20 1.5H4a.25.25 0 0 0-.25.25v7h16.5ZM3 10.25h18c.8284 0 1.5.6716 1.5 1.5V18c0 .8284-.6716 1.5-1.5 1.5H3c-.8284 0-1.5-.6716-1.5-1.5v-6.25c0-.8284.6716-1.5 1.5-1.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuLogs'
);
